angular.module 'zc.users.pages', [
  'zc.core'
  'zc.users'
]




// WEBPACK FOOTER //
// ./src/zenclerk_modules/users.pages/index.js.coffee